/**
 * Pricing constants for the paid Professional Consultation.
 * Mirrors backend `CONSULTATION_FEE_IDR` / `CONSULTATION_WINDOW_MIN`.
 */
export const CONSULTATION_FEE_IDR = 20000;
export const CONSULTATION_WINDOW_MIN = 10;
export const CONSULTATION_FEE_DISPLAY = "Rp 20.000";
